<app-system-message-banner audience="specialist"></app-system-message-banner>
<div class="container-fluid py-5">
    <div class="col-md-8 cah-signup-card offset-0 offset-md-2 offset-lg-2 offset-md-0  mt-0 mt-lg-5">
        <div class="d-flex">
            <div class="cah-signup-sec px-0 shadow d-lg-block d-none d-sm-none">
                <div class="py-5 cah-p-lr-40 text-white">
                    <h1 class="fw-bolder cah-font-35 mb-4">Specialist <br>Sign In</h1>
                    <p class="cah-font-16 mb-5">Get access to your account</p>
                    <div class="text-center py-5"><img src="{{assets}}img/auth/speci-graphic-left.png"></div>
                </div>
            </div>
            <div class="w-100 px-0">
                <form [formGroup]="form">
                    <div class="w-100 cah-sign-up-step">
                        <div class="pt-5 px-5">
                            <h1 class="cah-m-b-30 fw-bolder text-center text-violet d-block d-lg-none">Specialist Sign In</h1>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Enter Username</mat-label>
                                    <input formControlName="email" matInput>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="form.controls['email'].hasError('required') && form.controls['email'].touched"
                                        >
                                        {{message.error[13]}}
                                    </div>
                                  
                                    <div class="mat-error error-message" *ngIf="form.controls['email'].hasError('accountNotVerified')"
                                        >
                                        {{message.error[23]}}
                                    </div>
                        
                                    <div class="mat-error error-message"
                                        *ngIf="form.controls['email'].hasError('invalidEmail') && form.controls['email'].touched"
                                        >
                                        {{message.error[24]}}
                                    </div>
                                    <div class="mat-error error-message" *ngIf="form.controls['email'].hasError('userNotActive')"
                                    >
                                    {{message.error[112]}}
                                </div>
                                    <div class="mat-error error-message"
                                        *ngIf="form.controls['email'].hasError('pattern') && form.controls['email'].touched"
                                        >
                                        {{message.error[14]}}
                                    </div>
                                    <div class="mat-error error-message"
                                        *ngIf="form.controls['email'].hasError('invalidLoginType')"
                                        >
                                        {{message.error[57]}}
                                    </div>
                                </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Enter Password</mat-label>
                                <input [type]="hide ? 'password' : 'text'" 
                                formControlName="password" 
                                maxlength="16" 
                                matInput>
                                <button  mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button" (click)="hide = !hide">
                                    <mat-icon *ngIf="!hide">visibility</mat-icon>
                                    <mat-icon *ngIf="hide">visibility_off</mat-icon>
                                  </button> 
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="form.controls['password'].hasError('required') && form.controls['password'].touched"
                                        >
                                        {{message.error[26]}}
                                    </div>
                                    <div class="mat-error error-message" 
                                    *ngIf="form.controls['password'].hasError('pattern') && form.controls['password'].touched">
                                    {{message.error[29]}}
                                </div>

                                    <div class="mat-error error-message" *ngIf="form.controls['password'].hasError('invalidPassword') "
                                        >
                                        {{message.error[25]}}
                                    </div>
    
                                </div>
                            </div>
                            <div class="d-flex justify-content-between mb-3 pb-3">
                                <mat-checkbox *ngIf="sessionService.isSessionTimeoutEnabled" formControlName="rememberMe" class="cah-font-16 cah-sign-in-remember-me" color="Primary">
                                    Remember me for 30 days
                                </mat-checkbox>
                                <span *ngIf="!sessionService.isSessionTimeoutEnabled"></span>
                                <a class="create-acc-link text-violet text-decoration-none ms-1 cah-font-16 text-center mt-" routerLink="../specialist-forgot-password">Forgot Password?</a>
                            </div>
                        </div>
                        <div class="px-5">
                            <button
                            type="submit"
                            [disabled]="!form.valid"
                            (click)="signIn(form.value)"
                             class="btn btn-violet btn-lg w-100 fs-5 h-60 mt-2">Sign In</button>

                            <div class="text-center mt-4 pb-5" *ngIf="!isSpecialtyIntakeEnabled">
                                <span class="text-gray cah-font-16">New to {{ themeService.getDisplayName() }}? </span><a class="create-acc-link text-violet text-decoration-none ms-1 cah-font-16" routerLink="../specialist-signup" style="white-space: nowrap;">Sign Up Now!</a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
